export default __webpack_public_path__ + "static/media/vault_1.6f16fb5c.mp4";